module.exports = __webpack_public_path__ + "static/media/ccLaraos.5b286e7a.svg";